export enum ConnectionStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected'
}

export type ConnectionRequest = {
  id: string;
  status: ConnectionStatus;
};

export interface PortfolioConnectionRequests {
  connected: boolean;
  incomingConnectionRequest: ConnectionRequest | null;
  outgoingConnectionRequest: ConnectionRequest | null;
}
